import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService } from '@root/app.service';
import { HttpClient } from '@angular/common/http';
import { PlatformType, PlatformInfo } from '@root/config';

@Component({
  selector: 'host-channel-menu',
  templateUrl: './channel-menu.component.html',
  styleUrls: ['./channel-menu.component.scss'],
})
export class ChannelMenuComponent implements OnInit {
  @Input() listOfChannel = [];
  @Output() onSelectChannel = new EventEmitter();

  loading = false;

  get isInternational() {
    return this.app.app.international;
  }

  constructor(private app: AppService, private http: HttpClient) {}

  ngOnInit() {
    this.loading = true;
    this.fetchChannelList();
  }

  private fetchChannelList() {
    this.http.get('/api/novice_guidance/v2/config').subscribe((rst: HttpRsp) => {
      this.listOfChannel = rst?.data?.channels;

      //#regin 暂时手动写死小红书和抖音
      // if (!this.isInternational) {
      //   const xhs = PLATFORM_TYPE_INFO[PLATFORM_TYPE.XHS];
      //   const dy = PLATFORM_TYPE_INFO[PLATFORM_TYPE.Douyin];
      //   this.listOfChannel.push({
      //     thirdparty_type: PLATFORM_TYPE.XHS,
      //     name: xhs?.name,
      //     logo: xhs?.icon_large,
      //     bg_color: xhs?.signalColor,
      //   });
      //   this.listOfChannel.push({
      //     thirdparty_type: PLATFORM_TYPE.Douyin,
      //     name: dy?.name,
      //     logo: dy?.icon_large,
      //     bg_color: dy?.signalColor,
      //   });
      // }

      //#endregin

      this.loading = false;
    });
  }

  clickChannel(channel) {
    this.onSelectChannel.emit(channel);
  }
}
